// src/config/apiConfig.js

export const BASE_URL = "https://acsdev.in/clothing/api/client";
export const UPLOAD_URL = "https://acsdev.in/clothing/uploads";
export const G_LOGIN_URL = "https://acsdev.in/clothing/api/google-login";
export const PAYMENT_URL = "https://acsdev.in/clothing";
    
// export const BASE_URL = "http://localhost/clothing/api/client";
// export const UPLOAD_URL = "http://localhost/clothing/uploads";
// export const G_LOGIN_URL = "http://localhost/clothing/api/google-login";
// export const PAYMENT_URL = "http://localhost/clothing";